import React from 'react';
import type { UiSettings } from '../types';

export const UiSettingsContext = React.createContext<{
  uiSettings: UiSettings;
} | null>(null);

export function UiSettingsProvider(props: UiSettingsProviderProps) {
  return (
    <UiSettingsContext.Provider value={{ uiSettings: props.uiSettings }}>
      {props.children}
    </UiSettingsContext.Provider>
  );
}

export type UiSettingsProviderProps = {
  children: React.ReactNode;
  uiSettings: UiSettings;
};

export const useUiSettings = () => {
  const context = React.useContext(UiSettingsContext);

  if (!context) {
    throw new Error('useUiSettings must be used within a UiSettingsProvider');
  }

  return context;
};
